<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-col
                cols="4"
              >
                <v-text-field
                  v-model="search"
                  placeholder="Key in material type name here"
                  append-icon="search"
                  label="Search material type"
                  hide-no-data
                  hide-selected
                  clearable 
                />
              </v-col>
              <v-col
                cols="4"
              >
                <v-select
                  v-model="statusFilter"
                  :items="items"
                  item-text="state"
                  item-value="value"
                  label="Material Type's Status"
                  placeholder="Active / Deleted"
                />
              </v-col>
            </v-row>
          </v-card-actions>
          
          <v-data-table
            :headers="headers"
            :items="filteredCourseMaterialTypes"
            :loading="loading"
            :search="search"
          >
            <template v-slot:item.name="{ item }">
              <div>
                <span>
                  {{ item.name }}
                </span>
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <span v-if="statusFilter">
                <setup-training-course-material-types-dialog-edit
                  v-if="$hasPermissionTo(['update course material types'])"
                  :material-type="item"
                  @updated="loadData"
                />
                <span class="mx-1" />
                <setup-training-course-material-types-dialog-delete
                  v-if="$hasPermissionTo(['delete course material types'])"
                  :material-type="item"
                  @deleted="loadData"
                />
              </span>
              <span v-else>
                <setup-training-course-material-types-dialog-restore
                  v-if="$hasPermissionTo(['delete course material types'])"
                  :material-type="item"
                  @restored="loadData"
                />
              </span>
            </template>
          </v-data-table>
        </v-card> 
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupTrainingCourseMaterialTypesDialogEdit: () => import('@/components/setup/training/course-material-types/DialogEdit'),
      SetupTrainingCourseMaterialTypesDialogDelete: () => import('@/components/setup/training/course-material-types/DialogDelete'),
      SetupTrainingCourseMaterialTypesDialogRestore: () => import('@/components/setup/training/course-material-types/DialogRestore'),
    },
    metaInfo () {
      return {
        title: 'Classroom Types',
      }
    },
    data () {
      return {
        courseMaterialTypes: [],
        trashedCourseMaterialTypes: [],
        headers: [
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Extension',
            align: 'left',
            value: 'extension',
          },
          {
            text: 'Actions',
            sortable: false,
            value: 'action',
          },
        ],

        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        loading: true,
      }
    },
    computed: {
      filteredCourseMaterialTypes () {
        return this.statusFilter ? this.courseMaterialTypes : this.trashedCourseMaterialTypes
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.loadCourseMaterialTypes()
        this.loadTrashedCourseMaterialTypes()
      },

      loadCourseMaterialTypes () {
        this.$api.courseMaterialTypes().list()
          .then(response => {
            this.courseMaterialTypes = response.data
            this.loading = false
          })
      },

      loadTrashedCourseMaterialTypes () {
        this.$api.courseMaterialTypes().listTrashed()
          .then(response => {
            this.trashedCourseMaterialTypes = response.data
          })
      },
    },
  }
</script>
